import { navigate } from '@reach/router'
import React from 'react'
import styled from 'styled-components'
import { InputWithLabel } from '../form'
import useGetCandidateList from '../jobs/jobDetails/candidateListModal/useGetCandidateList'
import Layout from '../layout'
import { Button, ListHeader, LoadingMore, Title } from '../ui'
import { EshotCandidate } from './eshotCandidate'
import { CandidateShortlist } from './eshotCandidate/setList'

const InputWrapper = styled.div`
  position: relative;
  display: grid;
  cursor: pointer;
  width: 100%;
  max-width: 300px;
`

const Eshot = () => {
  const [searchValue, setSearchValue] = React.useState('')
  const [location, setLocation] = React.useState('')
  const [shortlist, setShortlist] = React.useState([])
  let { data, fetchMore, isFetchingMore, search } = useGetCandidateList()
  React.useEffect(() => {
    search(searchValue, location)
  }, [searchValue, location, search])

  return (
    <Layout>
      <ListHeader list="clients">
        <Title>E-shot</Title>
        <Button type="button" onClick={() => navigate('/candidate')}>
          Back
        </Button>
      </ListHeader>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <InputWrapper style={{ marginRight: '1rem' }}>
          <InputWithLabel
            name="search"
            label="Name"
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            placeholder="Search candidate"
          />
        </InputWrapper>
        <InputWrapper>
          <InputWithLabel
            name="location"
            label="Location"
            value={location}
            onChange={e => setLocation(e.target.value)}
            placeholder="Search location"
          />
        </InputWrapper>
      </div>
      <CandidateShortlist
        candidates={data}
        shortlist={shortlist}
        setShortlist={setShortlist}
      />
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          marginBottom: '1.5rem',
        }}
      >
        {fetchMore ? (
          isFetchingMore ? (
            <LoadingMore>Loading...</LoadingMore>
          ) : (
            <Button onClick={() => fetchMore()}>Load more</Button>
          )
        ) : null}
      </div>
      <EshotCandidate shortlist={shortlist} setShortlist={setShortlist} />
    </Layout>
  )
}

export default Eshot
